import * as React from 'react';
import {connect} from 'react-redux';
import {Row, Col} from 'react-bootstrap';
import {getLogo} from '../../../../util/helpers';
import {Email} from '../../../../components/Email';

class Contacts extends React.Component {

  public render() {
    return (
      <div className="container content-page">
        <Row>
          <Col sm={12}>
            <h2>Contacts</h2>

            <h3>Vous souhaitez contacter notre équipe <img width={120} src={getLogo()}/> : </h3>
            <ul>
              <li>écrivez à <Email email={'rcpro.france@msamlin.com'}/></li>
              <li>appelez le 01 44 70 71 00 (du lundi au vendredi de 9h à 18h)</li>
            </ul>
            <h3>Vous souhaitez contacter notre équipe indemnisation *: </h3>
            <ul>
              <li>
                <span>écrivez à </span>
                <Email email={'indemnisation.france@msamlin.com'}/> en indiquant la référence de votre contrat.
              </li>
            </ul>
            <p>
              * Les déclarations de sinistre s’effectuent en complétant le formulaire disponible dans votre
              espace personnel. Le traitement de votre dossier est ensuite effectué par notre équipe indemnisation.
            </p>
            <div className={'alert alert-default border'}>
              <p>
                Vous êtes intermédiaires en assurance, banque ou immobilier et vous réalisez un chiffre
                d’affaires annuel supérieur à 750 000 € : contactez notre équipe
                à <Email email={'rcpro.france@msamlin.com'}/> pour obtenir un devis.
              </p>
            </div>
            <p>
              MS Amlin <br/>
              58 bis rue La Boétie <br/>
              75 008 Paris <br/>
              T : 01 44 70 71 00 <br/>
              @ : <Email email={'contact.france@msamlin.com'}/> <br/>
              <a href="https://www.msamlin.com/en/markets/France.html" target="_blank">msamlin.com/france</a>
            </p>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect()(Contacts);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Brochure/scenes/Contacts/index.tsx